export const sanitizePhoneNumber = (number) => {
  // Adding leading 0 to make sure that screen readers annouce the numbers separately
  const phoneNumber = number.startsWith('0') ? number : `0${number}`;
  return phoneNumber.replace(/\s/g, '');
};

export const phoneNumberURI = (number) => {
  // Remove the leading 0 and all spaces in URL
  const phoneNumber = number.replace(/^0+/, '').replace(/\s+/g, '');
  // return with "tel: prefix and "+44" country code
  return `tel:+44${phoneNumber}`;
};
